export const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'image/*': ['.png', '.jpg', '.jpeg'],
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
